<template>
    <component
        :is="headingTag"
        :class="['title-text', `title-text--level-${normalizedLevel}`]"
        role="heading"
        :aria-level="level"
    >
        <slot />
    </component>
</template>

<script>

export default{
    name: 'TitleText',
    props: {
        level: {
            type: [String, Number],
            default: 1,
            validator: value => [1, 2, 3, 4, 5, 6].includes(Number(value))
        }
    },
    computed: {
        normalizedLevel() {
            return Number(this.level);
        },
        headingTag() {
            return `h${this.level}`;
        }
    }
};

</script>

<style scoped lang='scss'>
    .title-text {
        color: #2F363E;

        &--level-1 {
            font-size: 1.5rem;
            font-weight: 700;
        }

        &--level-2 {
            font-size: 1.25rem;
            font-weight: 700;
        }

        &--level-3 {
            font-size: 1rem;
            font-weight: 600;
        }
    }

    .title-text:not([class*='spacing-']) {
        margin-bottom: 0;
    }
</style>
